import { Get } from './BaseService';
import { API_URL } from '../../config/api';

const urlAreaNaoLogada = `${API_URL}/Configuracao`;

export async function SalesEnabled () {
   
    const endpoint = '/HabilitarVendasNova';
    const headers = { 
        'Accept': 'application/json',
    };


    return await Get(urlAreaNaoLogada + endpoint, headers);
}

export async function Consult (key) {
   
    const endpoint = '/Consultar?chave=' + encodeURIComponent(key);
    const headers = { 
        'Accept': 'application/json',
    };
    

    return await Get(urlAreaNaoLogada + endpoint, headers);
}

